/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusVerlaufListResponseDto } from '../../models/lexplus-verlauf-list-response-dto';

export interface AnforderungDetailControllerGetAnforderungNotizVerlaufV1$Params {
  anforderungsversionID: number;
  verlaufID: string;
  page?: number;
  limit?: number;
}

export function anforderungDetailControllerGetAnforderungNotizVerlaufV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerGetAnforderungNotizVerlaufV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusVerlaufListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerGetAnforderungNotizVerlaufV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.path('verlaufID', params.verlaufID, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusVerlaufListResponseDto>;
    })
  );
}

anforderungDetailControllerGetAnforderungNotizVerlaufV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/notizen/{verlaufID}/verlauf';
